import { type ActionItem, showToast } from 'shared/ui'
import { type Phone } from 'entities/Phone/model/Phone'
import { PhoneApi } from 'entities/Phone'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export const cancelNumberLandline = (
  phone: Phone,
  onSuccess: () => Promise<void>,
  entities: IEntitiesStore
): ActionItem => {
  const onAction = async () => {
    try {
      await PhoneApi.deleteNumbersLandLineDelete({
        phone: phone.number,
      })
      Promise.all([entities.subscriptionStore.init(), onSuccess()]).catch(console.error)
      showToast({
        type: 'success',
        title: 'Your landline number was removed.',
      })
    } catch (e: unknown) {
      showToast({
        type: 'error',
        title: 'Your landline number not removed. Something went wrong.',
      })
    }
  }

  return {
    icon: 'slashCircle',
    text: 'Cancel',
    onAction,
  }
}
